import Tasks from './TasksByPathway';

export default Tasks;
